import { Skeleton } from '@mui/material';
import { PlayerGrid, WaveformContainer } from './styles';

const PlayerSkeleton = () => (
  <PlayerGrid
    sx={{
      '.MuiSkeleton-root': {
        height: '100%',
      },
    }}
  >
    <Skeleton variant="rectangular" />
    <Skeleton variant="rectangular" />
    <Skeleton variant="rectangular" component={WaveformContainer} />
  </PlayerGrid>
);

export default PlayerSkeleton;
